<template>
  <ul class="nav nav-tabs">
    <li v-for="(tab, index) in tabs" :key="index" class="nav-item">
      <router-link class="nav-link" active-class="active" :to="tab.path">{{ tab.name }}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
